import { FlexibleBaseSpecification, FlexibleModelBase } from './flexible_base';

export interface FlexibleRecentVisitsSpecification extends FlexibleBaseSpecification {
	title: string;
}

export class FlexibleRecentVisitsModel extends FlexibleModelBase {
	public readonly title: string;

	constructor(spec: FlexibleRecentVisitsSpecification) {
		super(spec);

		this.title = spec.title;
	}
}
